<template>
	<nav class="filter-menu">
		<div class="filter-menu-dropdowns d-flex background-is-light-grey justify-content-center align-items-center" v-inview:on="inview" >

			<div class="filter-menu-heading-container" @click="expandFilters"> <label class="filter-menu-heading heading-4 "><slot name="hl-filtermenu-filterheading"></slot></label><span class="icon-minus" v-if="filtersExpanded" >—</span><span class="icon-plus" v-if="!filtersExpanded" >+</span></div>


			<filtering-dropdown v-for="menu in Menus" :Label="menu.Label" :items="menu.Items" :ref="'menu-' + menu.Label" :key="menu.Label" :class="{ 'filter-menus-hidden': !filtersExpanded } ">
			</filtering-dropdown>


			<button class="no-border blue-link filter-menu-clear-button" @click="clearFilters()" :class="{ 'filter-menus-hidden': !filtersExpanded } "><slot name="hl-filtermenu-clearfilters"></slot></button>
			<button class="hl-button filter-menu-apply-button" @click="clickApply" :class="{ 'filter-menus-hidden': !filtersExpanded } "><slot name="hl-filtermenu-apply"></slot></button>
		</div>


	<div class="d-md-flex mb-4">
		<div class="filter-menu-tags w-100">
			<transition-group name="filter-menu-list" class="list-unstyled mb-0" tag="ul">
				<li class="list-item filter-menu-list-item" v-for="tag in tags" v-bind:key="tag.FieldValue">
					<button class="filter-menu-tags-button" @click="clearTag(tag)" >
						<span class="filter-menu-tags-button-label">{{tag.Label}}</span>
						<span class="filter-menu-x-icon bg-icon"></span></button>
				</li>

			</transition-group>

		</div>
		<div class="filter-menu-list-sort mt-4 mt-md-0 text-md-right" v-if="isTeamPage"> 
			<button class="blue-link filter-menu-list-sort-button" @click="toggleSortAlpha">{{alphaText}}<span class="bg-icon filter-menu-list-sort-icon"></span></button>
		</div>
		</div>

		<div class="filter-menu-mobile-bar background-is-white py-3 px-4" v-if="numFilters > 0">
			<span class="heading-4">{{numFilters}} {{filterText}} SELECTED</span>
			<button class="no-border blue-link filter-menu-clear-button" @click="clearFilters()"><slot name="hl-filtermenu-clearfilters"></slot></button>
			<button class="hl-button filter-menu-apply-button" @click="clickApply"><slot name="hl-filtermenu-apply"></slot></button>
		</div>
	</nav>

</template>

<style lang="scss">
	.filter-menu {
		.filter-menu-mobile-bar {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			z-index: 5;
			height: 80px;

			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;

			border-top: 1px solid $lightGrey2;

			.filter-menu-clear-button, .filter-menu-apply-button {
				margin: 0 !important;
			}

			span, button {
				font-size: 14px;
				margin-bottom: 0;
			}

			@include respond-above(lg) {
				display: none;
			}

		}
		@include respond-below(lg) {
			.filter-menu-clear-button, .filter-menu-apply-button {
				margin: auto;
				margin-bottom: 1.5em;
			}
		}

		.filter-menu-tags {
			@include respond-below(lg) {
				display: none;
			}
		}

		.filter-menu-tags-button-label {
			margin-right: 0.35em;
		}
		.filter-menu-x-icon {
			background-image: get-icon( 'close-icon', $navyBlue );
			width: 11px;
			height: 11px;
		}
		.filter-menu-dropdowns {
			flex-wrap: wrap;
			padding: 1.5em;
			min-height: 60px;
			margin-bottom:  $bigPaddingSize/2;

			@include respond-above(lg) {
				& > *:not(:last-child) {
					margin-right: 1em;
				}
			}

			@include respond-between(lg, xxl) {
				.filtering-dropdown 
				{
					min-width: 180px;

				}

			}
			@include respond-below(lg) {
				padding: 1em;
				flex-direction: column;
				align-items: flex-start!important;

				.filtering-dropdown 
				{
					min-width: 150px;
					margin-bottom: 1em;

				}
			}
		}

		.filter-menu-tags {
			.filter-menu-list-item {
				display: inline-block;


				margin-right: 1em;
				margin-bottom: 1em;
				
			}
			.filter-menu-tags-button {
				padding: 0.5em 1em;
				border: 1px solid $lightGrey;
				background: transparent;
				min-width: 100px;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}

		.filter-menu-list-sort {
			@include respond-above(md) {
    			min-width: 300px;
				// display: flex;
				// align-items: flex-end;
				// flex-direction: column;
				// justify-content: center;
			}

		}

		.filter-menu-list-sort-button {
			.filter-menu-list-sort-icon {
				width: 15px;
				height: 10px;
				background-image: get-icon( 'forward-arrow', $navyBlue );
				background-repeat: no-repeat;
				margin-left: 5px;
			}
		}

		.filter-menu-list-item {
			display: inline-block;
			margin-right: 10px;
		}

		.filter-menu-list-enter-active, .filter-menu-list-leave-active {
			transition: all 0.15s;
		}

		.filter-menu-list-enter, .filter-menu-list-leave-to {
			opacity: 0;
			transform: translateX(30px);
		}



		.filter-menu-heading-container {
			@include respond-below(lg) {
				display: flex;
    			align-items: center;
    			justify-content: space-between;
    			width: 100%;
				padding: 0.5em 1.5em;
				padding-right: 2.2em;
			}

			.filter-menu-heading {
				margin: 0;
				padding: 0;
				padding-right: 1.5em;
				@include respond-below(lg) {
					text-align: left;
					
					
					padding: 0;
					margin-right: 0 !important;
		
					font-size: rem(16);


				}
			}

			.icon-plus {
				font-size: 2rem;
				font-weight: 200;
				line-height: 2rem;
				@include respond-above(lg) {
					display: none;
				}
			}
			.icon-minus {
				font-size: 1.5rem;
				font-weight: 200;
				line-height: 2rem;
				@include respond-above(lg) {
					display: none;
				}
			}
		}

		.filter-menus-hidden {
			display: none;
		}

	}
</style>

<script>
	// import Link from "../components/Link";
	import HButton from "../components/HButton";
	import FilteringDropdown from "../components/FilteringDropdown";
	import Vue from 'vue';
	
export default {
	components: {
		FilteringDropdown,
		HButton
	},
	data() {
		return {
			isInview: false,
			filtersExpanded: true,
		}
	},
	mounted() {
		if(window.matchMedia("(max-width: 992px)").matches) {
			this.filtersExpanded = false;
		} else {
			this.filtersExpanded = true;
		}
	},
	props: {
		isTeamPage: {
			type: Boolean,
			default: false
		},
		showAlphabetically: {
			type: Boolean,
			default: false
		},
		Menus: 
		{
			type: Array,
			default: function() {
				return [ ]
			}
		},
		tags: {
			type: Array,
			default: []
		},
		Label: {
			type: String,
			default: ""
		}
	},
	computed: {
		numFilters() {
			const menuCounter = (accumulator, menuItem) => { return menuItem.isChecked ? accumulator + 1 : accumulator };

			return this.Menus.reduce( (accumulator, menu) => menu.Items.reduce(menuCounter, accumulator), 0)
		},
		filterText() {
			if(this.numFilters > 1) {
				return "FILTERS";
			} else {
				return "FILTER";
			}
		},
		alphaText() {
			if(!this.showAlphabetically) {
                return this.$slots["hl-filtermenu-viewbyalpha"][0].text.trim();
			} else {
                return this.$slots["hl-filtermenu-viewbyteam"][0].text.trim();
			}
		}
	},
	methods: {
		inview($v) {
			$v.enter = (el) => {
				this.isInview = true;
				//console.log("ENTER");
			}
			$v.exit = (el) => {
				this.isInview = false;
				//console.log("EXIT");
			}

			
		},
		toggleSortAlpha() {

			this.$nextTick( () => {
				this.$emit('toggle-sort');
			});
	
		},
		clearFilters() {
			this.Menus.forEach(menu => {
				menu.Items.forEach( item => {
					item.isChecked = false;
				});
			});	

			this.$emit('apply-filters')	
		},
		clearTag(tag) {
			tag.isChecked = false;

			this.$emit('apply-filters')	
		},
		clickApply() {
			this.$emit('apply-filters')	
		},
		expandFilters() {
			if(window.matchMedia("(max-width: 992px)").matches) {
				this.filtersExpanded = !this.filtersExpanded;
			}
		}
	}
}
</script>

